// TypeScript-first Organization API - No runtime validation needed

import { apiBaseUrls } from "src/platform/constants/shared-constants";
import API from "src/platform/http/shared-http";

import {
  Organization,
  CreateOrganizationRequest,
  UpdateOrganizationRequest,
  OrganizationListResponse,
} from "../types";

const ORGANIZATION_BASE_URL = "/api/v1/organizations";

export class OrganizationApi {
  async getOrganization(alias: string): Promise<Organization> {
    const api = new API(
      apiBaseUrls.BACKEND,
      `${ORGANIZATION_BASE_URL}/${alias}`,
    );
    return await api.get<Organization>();
  }

  async getOrganizations(
    page: number = 1,
    limit: number = 10,
  ): Promise<OrganizationListResponse> {
    const queryParams = `?offset=${(page - 1) * limit}&limit=${limit}`;
    const api = new API(
      apiBaseUrls.BACKEND,
      `${ORGANIZATION_BASE_URL}${queryParams}`,
    );
    return await api.get<OrganizationListResponse>();
  }

  async createOrganization(
    request: CreateOrganizationRequest,
  ): Promise<Organization> {
    const api = new API(apiBaseUrls.BACKEND, ORGANIZATION_BASE_URL);
    return await api.post<Organization>(request);
  }

  async updateOrganization(
    alias: string,
    request: UpdateOrganizationRequest,
  ): Promise<Organization> {
    const api = new API(
      apiBaseUrls.BACKEND,
      `${ORGANIZATION_BASE_URL}/${alias}`,
    );
    return await api.patch<Organization>(request);
  }

  async deleteOrganization(alias: string): Promise<void> {
    const api = new API(
      apiBaseUrls.BACKEND,
      `${ORGANIZATION_BASE_URL}/${alias}`,
    );
    return await api.delete<void>();
  }

  async getOrganizationByUser(userId: string): Promise<Organization[]> {
    const api = new API(
      apiBaseUrls.BACKEND,
      `${ORGANIZATION_BASE_URL}/user/${userId}`,
    );
    return await api.get<Organization[]>();
  }

  async setDefaultOrganization(alias: string): Promise<Organization> {
    const api = new API(
      apiBaseUrls.BACKEND,
      `${ORGANIZATION_BASE_URL}/${alias}/default`,
    );
    return await api.patch<Organization>({});
  }

  async updateOrganizationStatus(
    alias: string,
    status: string,
  ): Promise<Organization> {
    const api = new API(
      apiBaseUrls.BACKEND,
      `${ORGANIZATION_BASE_URL}/${alias}/status`,
    );
    return await api.patch<Organization>({ status });
  }
}

export default new OrganizationApi();
